<nb-card class="checkout-card" [class.checkout-card--page]="pageMode" dir="rtl">
  <form class="form-checkout" [formGroup]="form" (ngSubmit)="submit()">
    <nb-card-header class="header">
      <span class="title">
        {{ isForUser ? 'ثبت برداشت برای کاربر' : 'درخواست برداشت' }}
      </span>

      <div class="actions">
        <button
          *ngIf="!pageMode && !isForUser"
          nbButton
          outline
          status="primary"
          class="requests-page-button"
          type="button"
          [disabled]="loading"
          (click)="openRequestsPage()"
        >
          <nb-icon icon="list-outline"></nb-icon>
          لیست درخواست‌های برداشت
        </button>

        <button *ngIf="!pageMode" nbButton status="basic" type="button" (click)="close()">
          بستن
        </button>

        <button
          class="request-btn"
          nbButton
          status="primary"
          type="submit"
          [disabled]="loading || form.invalid"
        >
          {{ loading ? 'در حال ارسال...' : 'ثبت درخواست' }}
        </button>
      </div>
    </nb-card-header>

    <nb-card-body>
      <div *ngIf="isForUser" class="target-user-summary">
        <div>
          <span>کاربر مقصد</span>
          <strong>{{ targetUserName }}</strong>
        </div>

        <div *ngIf="user?.balance !== undefined && user?.balance !== null">
          <span>موجودی کیف پول</span>
          <strong>{{ user?.balance | number }} تومان</strong>
        </div>
      </div>

      <div class="form-fields--grid">
        <ngx-input-field
          formControlName="amount"
          type="price"
          label="مبلغ"
          placeholder="150,000"
          [control]="amountControl"
        ></ngx-input-field>

        <div
          class="card-number-field"
          (click)="openCardsDropdown()"
          (focusin)="openCardsDropdown()"
          (focusout)="onCardFieldFocusOut($event)"
        >
          <ngx-input-field
            formControlName="cardNumber"
            label="شماره کارت"
            placeholder="6037991234567890"
            [control]="cardNumberControl"
            [inputAttrs]="{
              maxlength: 19,
              minlength: 16,
              pattern: '^[0-9]{16,19}$',
            }"
          ></ngx-input-field>

          <div
            *ngIf="!isForUser && cardsDropdownOpen"
            class="saved-cards-dropdown"
          >
            <div class="saved-cards-header">
              <span>کارت‌های ذخیره‌شده</span>

              <button
                nbButton
                ghost
                size="small"
                status="basic"
                type="button"
                [disabled]="savedCardsLoading"
                (click)="loadSavedCards(); $event.stopPropagation()"
              >
                <nb-icon icon="refresh-outline"></nb-icon>
              </button>
            </div>

            <div *ngIf="savedCardsLoading" class="state-box">
              در حال دریافت کارت‌ها...
            </div>

            <div
              *ngIf="!savedCardsLoading && !savedCards.length"
              class="saved-cards-empty"
            >
              کارت ذخیره‌شده‌ای وجود ندارد؛ می‌توانید شماره کارت دلخواه را وارد
              کنید.
            </div>

            <div
              *ngIf="!savedCardsLoading && savedCards.length"
              class="saved-cards-list"
            >
              <button
                nbButton
                type="button"
                status="basic"
                class="saved-card-option"
                [class.saved-card-option--selected]="isSavedCardSelected(card)"
                *ngFor="let card of savedCards"
                (click)="selectSavedCard(card)"
              >
                <span class="saved-card-option__content">
                  <span class="saved-card-option__main">
                    <span class="saved-card-option__title">
                      {{ card?.title || card?.bank || 'کارت بانکی' }}
                    </span>

                    <span
                      *ngIf="card?.isPrimary"
                      class="saved-card-option__chip"
                    >
                      اصلی
                    </span>
                  </span>

                  <span class="saved-card-option__number">
                    {{ formatCardNumber(card?.cardNumber) || '-' }}
                  </span>

                  <span *ngIf="card?.sheba" class="saved-card-option__sheba">
                    {{ card.sheba }}
                  </span>
                </span>
              </button>
            </div>
          </div>
        </div>

        <ngx-input-field
          class="field--full-grid"
          formControlName="sheba"
          label="شماره شبا"
          placeholder="IR2804928348293482304209384"
          [control]="shebaControl"
          [inputAttrs]="{
            maxlength: 26,
            minlength: 26,
            pattern: '^IR[0-9]{24}$',
          }"
        ></ngx-input-field>

        <ngx-input-field
          class="field--full-grid"
          formControlName="description"
          type="textarea"
          label="توضیحات"
          placeholder="توضیحات درخواست برداشت (اختیاری)"
          [control]="descriptionControl"
          [inputAttrs]="{ maxlength: 500 }"
        ></ngx-input-field>
      </div>

      <div *ngIf="!isForUser && showHistory" class="checkout-list-section">
        <div class="checkout-list-header">
          <h6>لیست درخواست‌های برداشت</h6>
        </div>

        <div *ngIf="checkoutListLoading" class="state-box">
          در حال دریافت درخواست‌ها...
        </div>

        <div
          *ngIf="!checkoutListLoading && !checkoutItems.length"
          class="state-box"
        >
          هنوز درخواستی ثبت نشده است.
        </div>

        <div
          *ngIf="!checkoutListLoading && checkoutItems.length"
          class="checkout-list"
          (scroll)="onCheckoutListScroll($event)"
        >
          <div class="checkout-item" *ngFor="let item of checkoutItems">
            <div class="checkout-item__main">
              <strong> {{ item?.amount || 0 | number }} تومان </strong>

              <span
                class="status-badge"
                [ngClass]="getStatusClass(item?.status)"
              >
                {{ getStatusLabel(item?.status) }}
              </span>
            </div>

            <div class="checkout-item__meta">
              <span>
                کد پیگیری:
                {{ item?.transaction || '-' }}
              </span>

              <span>
                توضیحات:
                {{ item?.description || '-' }}
              </span>

              <span>
                شماره کارت:
                {{ item?.cardNumber || '-' }}
              </span>

              <span>
                شماره شبا:
                {{ item?.sheba || '-' }}
              </span>

              <span>
                تاریخ ثبت:
                {{ formatCheckoutDate(item?.createdAt) }}
              </span>
            </div>
          </div>

          <div *ngIf="checkoutListLoadingMore" class="state-box">
            در حال دریافت موارد بیشتر...
          </div>

          <div
            *ngIf="!checkoutHasMore && checkoutItems.length"
            class="state-box"
          >
            همه درخواست‌ها نمایش داده شد.
          </div>
        </div>
      </div>
    </nb-card-body>
  </form>
</nb-card>
